import React, {useCallback, useState} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {CustomText} from '@buncha/components/core/text';
import {HBox} from '@buncha/components/core/view';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import ReprintModal from './ReprintModal';
import SmallPrinter from '@buncha/components/core/icon/SmallPrinter';
import {StyleSheet} from 'react-native';
import {Touchable} from '@buncha/components/core/touchable';
import {useGetLocale} from '@buncha/localization/hooks';

interface ReprintBarcodesProps {
  orderIds: number[];
  b2BOrderIds: number[];
  barcodesLength: number;
}

const ReprintBarcodes: React.FC<ReprintBarcodesProps> = props => {
  const theme = useColorThemeType('main');
  const muli = useFontTheme('muli');
  const {body} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = useCallback(() => {
    setModalOpen(!modalOpen);
  }, [modalOpen]);
  return (
    <React.Fragment>
      <Touchable onPress={toggleModal}>
        <HBox style={styles.touchableBox}>
          <SmallPrinter
            height={28}
            width={28}
            viewBox="1 -5 18 28"
            fill={theme?.icon?.blue?.[100]}
          />
          <CustomText
            style={{
              color: theme?.text?.blue?.[100],
              fontFamily: muli?.[700]?.normal,
            }}>
            {body?.reprintBarcodes}
          </CustomText>
        </HBox>
      </Touchable>
      <ReprintModal
        open={modalOpen}
        onClose={toggleModal}
        orderIds={props?.orderIds}
        barcodesLength={props?.barcodesLength}
        b2BOrderIds={props?.b2BOrderIds}
      />
    </React.Fragment>
  );
};
export default React.memo(ReprintBarcodes);

export const styles = StyleSheet.create({
  touchableBox: {
    gap: 10,
    justifyContent: 'center',
    alignSelf: 'center',
    alignItems: 'center',
    padding: 5,
  },
});
